import { useQuery } from "@tanstack/react-query";
import { getMachineToken } from "controller/api";
import { debugConsole } from "utilz/helpers";

export const useGetMachineToken = () => {
  return useQuery({
    queryKey: ["machineToken"],
    queryFn: () => getMachineToken(),
    onError: (error) => debugConsole(error),
  });
};
